/**
 * Created by Ella Ma on 07/12/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription, of as observableOf } from 'rxjs';
import { catchError, take, filter } from 'rxjs/operators';
import { Router } from '@angular/router';

import { AuditTrailService } from '../../../tamalelibs/services/audit-trail.service';
import { GridConfig, GridEventType, DataList, GridActionType } from '../../../widgets/grid/grid.config';
import { COLUMNDEFS } from './audit-log-grid.model';
import { GridLogConfig, GridLogActionType, GridPageParams, GridLogEventType } from './audit-log-grid.config';

@Component({
    selector: 'tam-audit-log-grid',
    templateUrl: './audit-log-grid.component.html',
    styleUrls: ['./audit-log-grid.component.scss']
})

export class AuditLogGridComponent implements OnInit, OnDestroy {

    @Input() config: GridLogConfig;
    @Input() objectType: string;
    /**
     * Fired after the grid data is loaded.
     */
    @Output() gridLoaded = new EventEmitter<boolean>();
    gridConfig: GridConfig;
    reloading = false;

    private _gridPageParams: GridPageParams;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _APIServices: AuditTrailService,
        private _router: Router
    ) { }

    ngOnInit() {
        this._gridPageParams = new GridPageParams();
        this.gridConfig = new GridConfig();
        this.gridConfig.columnDefs = COLUMNDEFS;
        this._destroySubscriptions.push(
            this.gridConfig.events$.pipe(
                filter((item) => item.type === GridEventType.onBodyScroll)
            ).subscribe((params) => {
                Object.assign(this._gridPageParams, params.payload);
                this.getAduitList(GridActionType.loadMore);
            }),
            this.gridConfig.events$.pipe(
                filter((item) => item.type === GridEventType.onSort)
            ).subscribe((params) => {
                this.gridConfig.action$.next({ type: GridActionType.resetPage });
                this._gridPageParams.page = 1;
                Object.assign(this._gridPageParams, params.payload);
                this.reloading = true;
                this.config.events$.next({ type: GridLogEventType.sortParamsToGet, payload: params.payload });
                this.getAduitList();
            }),
            this.config.actions$.pipe(
                filter((data) => data.type === GridLogActionType.reloadGrid)
            ).subscribe((data) => {
                this.gridConfig.action$.next({ type: GridActionType.resetPage });
                this._gridPageParams.page = 1;
                this._gridPageParams.filter = data.payload;
                this.reloading = true;
                this.getAduitList();
            })
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    getAduitList(type?: GridActionType) {
        this._destroySubscriptions.push(
            this._APIServices.getAduitList(this._gridPageParams, this.objectType).pipe(
                take(1),
                catchError((err) => {
                    if (this.reloading) {
                        this.reloading = false;
                        this.gridLoaded.emit(true);
                    }
                    this.config.events$.next({ type: GridLogEventType.totalUpdate, payload: 0 });
                    this.gridConfig.action$.next({ type: GridActionType.refreshGrid });
                    if (err.message && err.message.indexOf('401') > -1 && err.message.indexOf('Unauthorized') > -1) {
                        this._router.navigate(['error']);
                    }
                    return observableOf();
                })).subscribe((res) => {
                    if (this.reloading) {
                        this.reloading = false;
                        this.gridLoaded.emit(true);
                    }
                    if (!res['audit-list']) {
                        return;
                    }
                    const data = new DataList();
                    data.data = res['audit-list'];
                    data.total = res.count || 0;
                    this.config.events$.next({ type: GridLogEventType.totalUpdate, payload: data.total });
                    if (type === GridActionType.loadMore) {
                        this.gridConfig.action$.next({ type: GridActionType.loadMore, payload: data });
                    } else {
                        this.gridConfig.action$.next({ type: GridActionType.refreshGrid, payload: data });
                    }
                })
        );
    }
}

